import React from 'react';
import clsx from 'clsx';
import { Box } from '../Box';
import { responsiveCssProperties } from '../../utils';
import './Icon.css';
export const Icon = React.forwardRef(function Icon(props, ref) {
    const { src: icon, spinning, size, className, color, style, ...rest } = props;
    if (!icon)
        return null;
    return (React.createElement(Box.Restricted, { ...rest, elementType: icon, "aria-hidden": true, focusable: false, className: clsx('mollie-ui-icon', {
            'mollie-ui-icon--spinning': spinning,
        }, className), style: {
            ...style,
            ...responsiveCssProperties({
                '--mollie-ui-icon-color': color,
                '--mollie-ui-icon-size': size,
            }),
        }, ref: ref }));
});
//# sourceMappingURL=Icon.js.map